/**
 * Name: Loader reducer
 */
import { createSlice } from "@reduxjs/toolkit";

export const loader = createSlice({
  name: "loader",
  initialState: {
    loader: false,
  },
  reducers: {
    toggleLoader: (state, action) => {
      state.loader = action.payload;
    },
  },
});

export const toggleLoaderAsync = (val) => async (dispatch) => {
  try {
    console.log("loader,", val);
    dispatch(toggleLoader(val));
  } catch (err) {}
};

export const { toggleLoader } = loader.actions;
export const getLoaderValue = (state) => state?.loader?.loader;
export default loader.reducer;
